module.exports = __webpack_public_path__ + "img/i3dmetab.5d77efe1.png";